<template>
    <v-card>

        <v-card-title>Edit Alarm Condition</v-card-title>

        <v-divider />

        <v-card-text>
    
            <v-form ref="alarmConditionForm" class="fill-height pt-3" :lazy-validation="true" v-model="alarmConditionFormValid">
                <v-row dense >

                    <v-col cols="12" sm="6">
                        <v-text-field label="Office" color="#c42111" v-model="$props.alarmCondition.condition_office" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Location" color="#c42111" v-model="$props.alarmCondition.condition_location" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select label="Locale" v-model="locale" multiple color="#c42111" :items="$props.localeList">
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index < 1">{{ `${item}, ` }}</span>
                                <span v-if="index === 1">{{ `${item}` }}</span>
                                <span v-if="index === 2" class="grey--text caption">(+{{ locale.length - 2 }} others)</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select label="Severity" multiple v-model="severity" color="#c42111" :items="severityOptions" />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field label="Description" color="#c42111" v-model="$props.alarmCondition.condition_code" />
                    </v-col>



                    <v-col cols="12" sm="6" xl="3">
                        <v-text-field type="number" label="Repeats" color="#c42111" v-model="$props.alarmCondition.condition_repeats" :rules="[$store.state.validationFuncs.required($props.alarmCondition.condition_repeats, 'Value'), $store.state.validationFuncs.nonNegInteger($props.alarmCondition.condition_repeats)]" />
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                        <v-text-field type="number" label="Within" suffix="minutes" color="#c42111" v-model="$props.alarmCondition.condition_repeats_within_min" :rules="[$store.state.validationFuncs.required($props.alarmCondition.condition_repeats_within_min, 'Value'), $store.state.validationFuncs.nonNegInteger($props.alarmCondition.condition_repeats_within_min)]" />
                    </v-col>

                    <v-col cols="12" sm="6" xl="3">
                        <v-menu v-model="editAfterThisTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="$props.alarmCondition.condition_after_time" color="#c42111" label="After This Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                            </template>
                            <v-time-picker v-model="$props.alarmCondition.condition_after_time" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                        <v-menu v-model="editBeforeThisTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="$props.alarmCondition.condition_before_time" color="#c42111" label="Before This Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                            </template>
                            <v-time-picker v-model="$props.alarmCondition.condition_before_time" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="12">
                        <v-select label="Days of Week" multiple v-model="daysOfWeek" color="#c42111" :items="daysOfWeekOptions" />
                    </v-col>

                </v-row>

            </v-form>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer />
            <v-btn text @click="$emit('cancel')">cancel</v-btn>
            <v-btn text @click="saveClick">save</v-btn>
        </v-card-actions>

    </v-card>


</template>

<script>
export default {
    name: 'AlarmCondition',
    props: ['alarmCondition', 'localeList'],
    components: {

    },
    data: () => ({
        alarmConditionFormValid: true,
        severityOptions: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        isEditing: false,
        editingClone: null,
        editAfterThisTime: false,
        editBeforeThisTime: false,
        daysOfWeekOptions: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    }),

    computed: {
        locale: {
            get: function() {
                let arr = this.$props.alarmCondition.condition_locale.split('|');
                return arr[0] !== "" ? arr : null;
            },
            set: function(selectedLocales) {
                this.$props.alarmCondition.condition_locale = selectedLocales.join('|');
            }
        },

        severity: {
            get: function() {
                let arr = this.$props.alarmCondition.condition_orig_severity.split('|');
                return arr[0] !== "" ? arr : null;
            },
            set: function(selectedSeverities) {
                this.$props.alarmCondition.condition_orig_severity = selectedSeverities.join('|');
            }
        },

        daysOfWeek: {
            get: function() {
                let val = [];
                if(this.$props.alarmCondition.condition_days_sun){val.push('Sunday');}
                if(this.$props.alarmCondition.condition_days_mon){val.push('Monday');}
                if(this.$props.alarmCondition.condition_days_tue){val.push('Tuesday');}
                if(this.$props.alarmCondition.condition_days_wed){val.push('Wednesday');}
                if(this.$props.alarmCondition.condition_days_thu){val.push('Thursday');}
                if(this.$props.alarmCondition.condition_days_fri){val.push('Friday');}
                if(this.$props.alarmCondition.condition_days_sat){val.push('Saturday');}
                return val;
            },
            set: function(selectedDaysOfWeek) {
                this.$props.alarmCondition.condition_days_sun = selectedDaysOfWeek.includes('Sunday');
                this.$props.alarmCondition.condition_days_mon = selectedDaysOfWeek.includes('Monday');
                this.$props.alarmCondition.condition_days_tue = selectedDaysOfWeek.includes('Tuesday');
                this.$props.alarmCondition.condition_days_wed = selectedDaysOfWeek.includes('Wednesday');
                this.$props.alarmCondition.condition_days_thu = selectedDaysOfWeek.includes('Thursday');
                this.$props.alarmCondition.condition_days_fri = selectedDaysOfWeek.includes('Friday');
                this.$props.alarmCondition.condition_days_sat = selectedDaysOfWeek.includes('Saturday');
            }
        },

        isNew() {
            return this.$props.alarmCondition.condition_id == 0;
        }
    },

    methods: {
        saveClick: function() {
            if(this.$refs.alarmConditionForm.validate()) {
                this.$emit('save');
            }
        }
    },

    mounted() {
    }

  
};
</script>


<style scoped>

</style>
